import { Grid, GridColumn, GridNoRecords } from '@progress/kendo-react-grid'
import React from 'react'
import "./grid-signatures.css";

/**
 * @typedef {Object} Props
 * @prop {Array} dataGrid Arreglo de objetos el cuál el grid usará como datos
 * @prop {string} firstField Propiedad del objeto que tomará como referencia
 * @prop {string} firstTitle Titulo que tendrá la columna superior
 * @prop {JSX.Element} firstCustomCell Componente que iría en lugar de solo el texto en la celda
 * @prop {boolean} showSecondCol Booleano el cuál definirá si mostrar o no la columna
 * @prop {string} secondField Propiedad del objeto que tomará como referencia
 * @prop {string} secondTitle Titulo de la segunda columna superior
 * @prop {number | string} secondColWidth Ancho de la segunda columna, puede ser:
 * ```js
 * // Dependiendo de la cantidad deseada
 * const width = 500 || 600 || 700 
 * //Dependiendo del porcentaje
 * const width = "40%" || "50%" || "100%"
 * ```
 * @prop {string} secondColClassname Clase CSS que se asignará a la celda (solo aplica si se mandó al componente)
 * ```css
 * Clase que se creará
 * .clase {
 *  widht: 100%;
 * }
 * // Como se colocaría en el componente
 * ```
 *  ```html
 *  <div className="clase">
 *  ```
 */

/**
 * @author Pedro Antonio
 * @param {Props}
 * @description Componente puro para solicitud de firma (genérico)
 * @return {JSX.Element} 
 */
const GridSignatures = ({
    dataGrid = [],
    firstField,
    firstTitle,
    firstCustomCell,
    showSecondCol,
    secondField,
    secondTitle,
    secondColWidth,
    secondColClassname,
    secondHeaderClassname,
    showThirdCol,
    thirdField,
    thirdTitle,
    thirdColWidth,
    thirdColClassname,
    thirdHeaderClassname,
    showFourthCol,
    fourthField,
    fourthTitle,
    fourthCell,
    fourthHeaderCell,
    fourthColWidth,
    fourthColClassname,
    fourthHeaderClassname,
    showFifthCol,
    fifthField,
    fifthTitle,
    fifthColWidth,
    fifthColClassname,
    fifthFieldCell,
    noResultsText,
    showThirdProofLifeCol,
    ThirdProofLifeColWidth,
    ThirdProofLifeColTitle,
    ThirdProofLifeColField,
    ThirdProofLifeColCell,
    ThirdProofLifeColHeaderCell,
    ThirdProofLifeColHeaderClassname,
    ThirdProofLifeColClassname,
    showSixthCol,
    sixthField,
    sixthTitle,
    sixthCell,
    sixthHeaderCell,
    sixthColWidth,
    sixthColClassname,
    sixthHeaderClassname
}) => {
    const gridLabelNorecordsStyles = {
        color: "#828282",
        fontSize: "15px",
        fontWeight: 500,
    };

    return (
        <Grid
            data={dataGrid}
            className={"gridSignatures-grid"}
        >
            {(firstField || firstTitle) &&
                <GridColumn
                    title={firstTitle}
                    field={firstField}
                    cell={(params) => firstCustomCell(params)}
                />
            }
            {showSecondCol && (secondField && secondTitle) &&
                <GridColumn
                    width={secondColWidth}
                    className={secondColClassname}
                    title={secondTitle}
                    field={secondField}
                    headerClassName={secondHeaderClassname}
                />
            }
            {showThirdCol && (thirdTitle && thirdField) &&
                <GridColumn
                    width={thirdColWidth}
                    title={thirdTitle}
                    field={thirdField}
                    className={thirdColClassname}
                    headerClassName={thirdHeaderClassname}
                />
            }
            {
                showThirdProofLifeCol && (
                    <GridColumn
                        width={ThirdProofLifeColWidth}
                        title={ThirdProofLifeColTitle}
                        field={ThirdProofLifeColField}
                        cell={ThirdProofLifeColCell}
                        headerCell={ThirdProofLifeColHeaderCell}
                        headerClassName={ThirdProofLifeColHeaderClassname}
                        className={ThirdProofLifeColClassname}
                    />
                )
            }
            {showFourthCol && ((fourthTitle && fourthField) || fourthCell) &&
                <GridColumn
                    width={fourthColWidth}
                    title={fourthTitle}
                    field={fourthField}
                    cell={fourthCell}
                    headerCell={fourthHeaderCell}
                    headerClassName={fourthHeaderClassname}
                    className={fourthColClassname}
                />
            }
            {showSixthCol && (sixthTitle || sixthField || sixthCell) &&
                <GridColumn
                    width={sixthColWidth}
                    title={sixthTitle}
                    field={sixthField}
                    cell={sixthCell}
                    headerCell={sixthHeaderCell}
                    headerClassName={sixthHeaderClassname}
                    className={sixthColClassname}
                />
            }
            {showFifthCol && (fifthField || fifthTitle) &&
                <GridColumn
                    width={fifthColWidth}
                    title={fifthTitle}
                    field={fifthField}
                    headerClassName={fifthColClassname}
                    cell={(props) => fifthFieldCell(props)}
                />
            }
            <GridNoRecords>
                <p style={gridLabelNorecordsStyles}>
                    {noResultsText}
                </p>
            </GridNoRecords>
        </Grid>
    )
}

export default GridSignatures